---
pageId: concept-categories
title: Kategorie
description: Kategorie porządkują trackery w hierarchię, nadają im wspólny kolor i napędzają rekurencyjne filtrowanie w Dzienniku i Statystykach.
category: concepts
order: 3
lang: pl
slug: koncepty/kategorie
updated: 2026-08-06
---

Kategorie utrzymują porządek w rosnącym zbiorze trackerów. Każda kategoria ma nazwę, kolor i opcjonalną ikonę emoji — a kategorie się zagnieżdżają, więc „Zdrowie" może trzymać „Sen" i „Odżywianie" jako podkategorie z własnymi trackerami.

## Kolor spływa w dół, ikony nie

Tracker bez własnego koloru dziedziczy kolor swojej kategorii. Ustaw kolor trackera, żeby go nadpisać; wyczyść go, żeby wrócić do koloru kategorii. Ta jedna zasada utrzymuje spójny wygląd Dziennika, wyboru trackera w szybkim dodawaniu i statystyk — bez dłubania per tracker.

Ikony nie kaskadują — każdy tracker pokazuje własną ikonę albo neutralny glif zabarwiony jego efektywnym kolorem.

## Zarządzanie kategoriami

Wszystko dzieje się w **Ustawienia → Zarządzanie kategoriami**. Panel pokazuje kategorie jako drzewo z zagnieżdżonymi trackerami oraz sekcję **Bez kategorii** na dole dla trackerów bez przydziału.

- **Dodaj kategorię** tworzy kategorię najwyższego poziomu; menu każdej kategorii oferuje **Dodaj podkategorię**, **Edytuj kategorię** i **Usuń kategorię**.
- **Drag and drop** robi całą robotę: upuść kategorię na inną, żeby ją zagnieździć, nad lub pod nią, żeby zmienić kolejność, albo na strefę główną, żeby wyciągnąć ją na najwyższy poziom. Przeciągnij tracker na kategorię, żeby go przenieść, albo na strefę główną, żeby odpiąć go od kategorii.
- Edycja kategorii odsłania nazwę, kolor i emoji. Kolor i emoji trackera możesz też poprawić inline, wprost w drzewie.

Usunięcie kategorii nie niszczy danych: jej podkategorie przechodzą do rodzica usuwanej kategorii, a jej trackery stają się nieskategoryzowane.

## Filtrowanie jest rekurencyjne

Filtr po kategorii zawsze obejmuje całe jej poddrzewo — wybierz „Zdrowie", a wpisy z trackerów „Sen" i „Odżywianie" wchodzą automatycznie. Dotyczy to osi czasu Dziennika i filtrów na stronie Statystyk.

## Limity planów

Plan Free obejmuje 2 kategorie; Pro znosi limit.
